import React, { useContext } from 'react';
import { Typography, Button } from 'antd';
import { useTheme } from "../../../ThemeContext.js";
import { Row, Col } from 'react-flexbox-grid';
import SearchContext from '../../../context';
import light_bg from '../../../assets/bg/Taieri.svg';
import LangContext from '../../../context/LangContext/index.js';

const Hero = () => {

    const contextService = useContext(SearchContext);

    const { currentLangData } = useContext(LangContext);

    const themeState = useTheme(); 

    const { Title } = Typography;

    return(
        <Row className="no-margin main-container-hero" style={{ marginTop: 80, width: '100%', height: '100%' }} >
            <Col className="padding-hero" xs={12} sm={12} md={12} lg={6} style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column' }} >
                <span className="montserrat secondary-title-color" style={{ fontSize: '1.3rem' }} >
                    {currentLangData.HERO.title_1}
                </span>
                <Title className="main-title-color" style={{ padding: '.25em 0em', fontSize: contextService.width <= 426 ? '2.25rem' : '3.25rem' }}>
                    {currentLangData.HERO.title_2}
                </Title>
                <span className="montserrat secondary-title-color" style={{ fontSize: '1.3rem' }} >
                    {currentLangData.HERO.desc}
                </span>
                <div style={{ marginTop: '1.55em', width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'row' }} >
                    <a href="#proyectos" style={{ textDecoration: 'none' }}>
                        <Button type="primary" shape="round" size="large" className="main-cta" onClick={() => console.log('derp')} style={{ height: 50 }} >
                            <span className="no-margin montserrat" style={{ fontSize: '1.15rem' }}>
                                {currentLangData.HERO.cta}
                            </span>  
                        </Button>
                    </a>
                    <a href="#habilidades" style={{ textDecoration: 'none' }}>
                        <span className="montserrat accent-title-color" style={{ paddingLeft: '1em', fontSize: '1.15rem' }} >
                            {currentLangData.HERO.about}
                        </span>
                    </a>
                </div>
            </Col>
            {
                contextService.width <= 991 ? null : 
                <Col className="no-padding" xs={12} sm={12} md={12} lg={6}>
                    <img src={`${themeState.dark === false ? light_bg : light_bg}`} alt={`${themeState.dark === false ? light_bg : light_bg}`} style={{ width: '100%', height: '100%' }} />
                </Col>
            }
        </Row>
    )
}

export default Hero;